import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import { formatTime } from '../helpers';

export default function RhRunTable({ data }) {
  const [clicked, setClicked] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(0);
  function handleClick(event, rownum) {
    console.log(event, rownum);
    setClicked(!clicked);
    setSelectedRow(rownum);
  }

  let racerLaps = [];
  if (data.runJson && data.racerId) {
    racerLaps = data?.runJson?.results?.filter(
      (res) => res.racer_number === data?.racerId
    )[0]?.laps;
    // console.log(data?.racerId);
    // console.log(data?.runJson?.results);
    // console.log(racerLaps);
  }
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        RaceHero summary
      </Typography>
      <Typography variant="body1" gutterBottom>
        Total Race Time: 20:21 Total Laps: 13 Completed Laps: 13
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 250 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Lap Number</TableCell>
              <TableCell align="right">Position</TableCell>
              <TableCell align="right">Laptime (mm:ss:ms)</TableCell>
              <TableCell align="right">Laptime (ss:ms)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {racerLaps?.map((row, index) => (
              <TableRow
                hover
                key={index}
                selected={selectedRow === row.number}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
                onClick={(event) => handleClick(event, row.number)}
              >
                <TableCell component="th" scope="row">
                  {row.number}
                </TableCell>
                <TableCell align="right">{row.position}</TableCell>
                {/* kpw  */}
                <TableCell align="right">{formatTime(row.time)}</TableCell>
                <TableCell align="right">{row.time}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
